import ColoredCard from './ColoredCard';

export default ColoredCard;
